/**
 * Wizard 2 Klaviyo Integration
 * Extends KlaviyoEventManager to use wizard-2 backend endpoints
 */
(function() {
  if (typeof KlaviyoEventManager === 'undefined') return;

  class KlaviyoEventManagerWizard2 extends KlaviyoEventManager {
    getApiPrefix() {
      return 'wizard-2';
    }

    quizLocaleKey() {
      return 'wizard-2';
    }

    rememberQuizLocale(pendingEvent) {
      if (typeof window === 'undefined' || !window.WizardKlaviyoLocale) return null;
      return window.WizardKlaviyoLocale.remember(this.quizLocaleKey(), this, pendingEvent || null);
    }

    setLastOriginPath(origin, path) {
      super.setLastOriginPath(origin, path);
      this.rememberQuizLocale(null);
    }

    formatEventProperties(pets, cartItems) {
      const formatted = super.formatEventProperties(pets, cartItems || []);
      const savedLocale = this.rememberQuizLocale(null);
      if (savedLocale && window.WizardKlaviyoLocale) {
        window.WizardKlaviyoLocale.apply(formatted, savedLocale);
      }
      return formatted;
    }

    getStorageKey(customerEmail) {
      return `klaviyo_pending_event_wizard2_${customerEmail}`;
    }

    async startTimer(customerEmail) {
      this.cancelPendingEvent();
      const pendingEvent = this.loadPendingEvent(customerEmail);
      if (!pendingEvent) return;
      this.rememberQuizLocale(pendingEvent);
      this.savePendingEvent(customerEmail, pendingEvent);

      let remainingTime = this.timerDelay;
      if (pendingEvent.createdAt) {
        const elapsed = Date.now() - pendingEvent.createdAt;
        remainingTime = Math.max(0, this.timerDelay - elapsed);
      }

      if (remainingTime <= 0) {
        this.sendKlaviyoEvent(customerEmail);
        return;
      }

      try {
        const properties = this.formatEventProperties(pendingEvent.pets, pendingEvent.cartItems);
        const delayMinutes = Math.ceil(remainingTime / 60000);
        const res = await fetch(`${this.backendApiUrl}/api/wizard-2/schedule-quiz-event`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: pendingEvent.eventType,
            profile: pendingEvent.profile,
            properties,
            delayMinutes
          })
        });
        const data = await res.json().catch(() => ({}));
        if (data.ok && data.key) {
          pendingEvent.scheduleKey = data.key;
          this.savePendingEvent(customerEmail, pendingEvent);
        } else {
          this.fallbackToLocalTimer(customerEmail, remainingTime);
        }
      } catch (e) {
        this.fallbackToLocalTimer(customerEmail, remainingTime);
      }
    }

    async cancelScheduledEvent(key) {
      if (!key || !this.backendApiUrl) return;
      try {
        await fetch(`${this.backendApiUrl}/api/wizard-2/cancel-quiz-event`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ key })
        });
      } catch (e) {}
    }

    async sendKlaviyoEvent(customerEmail) {
      const pendingEvent = this.loadPendingEvent(customerEmail);
      if (!pendingEvent) return;
      this.rememberQuizLocale(pendingEvent);

      try {
        const properties = this.formatEventProperties(pendingEvent.pets, pendingEvent.cartItems);
        await this.cancelScheduledEvent(pendingEvent.scheduleKey);

        const response = await fetch(`${this.backendApiUrl}/api/wizard-2/send-quiz-event-now`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            eventType: pendingEvent.eventType,
            profile: pendingEvent.profile,
            properties
          })
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `HTTP ${response.status}`);
        }

        this.clearPendingEvent(customerEmail);
        this.pendingEvent = null;
      } catch (error) {
        console.error('Klaviyo event send failed:', error);
      }
    }
  }

  window.KlaviyoEventManagerWizard2 = KlaviyoEventManagerWizard2;
})();
